export default {
    newGroupRegistration: "Neue Gruppenanmeldung erstellen",
    newGroupBuy: "Neue Gruppenbestellung erstellen",
    editGroupRegistration: "Gruppenanmeldung bearbeiten",
    editGroupBuy: "Gruppenbestellung bearbeiten",
    groupRegistration: "Sie melden sich und ggf. weitere Personen zu dieser Veranstaltung mit folgender Gruppe an:",
    caregiverRegistration: "Sie melden sich und ggf. weitere Personen zu dieser Veranstaltung als Mitarbeiter an:",
    caregiverSelect: "Betreuerfunktion",
    invalidCaregiverToken: "Diese Betreuerfunktion kann nicht gewählt werden.",
    groupName: "Gruppenname",
    groupRegistrarMail: "Kontakt E-Mail",


    groupParticipantLink: "Link für Gruppenteilnehmende",
    groupParticipantLinkForBuy: "Link für Gruppenmitglieder",
    groupParticipantLinkExplanation: "Sie können diesen Link an Ihre Gruppenteilnehmenden weitergeben." +
        " Diese können sich dann zu Ihrer Gruppe anmelden",
    groupParticipantLinkForBuyExplanation: "Sie können diesen Link an Ihre Gruppenmitglieder weitergeben.",

    groupRegistrarLink: "Link für verantwortliche Person",
    groupRegistrarLinkForBuy: "Link für verantwortliche Person der Bestellung",
    groupRegistrarLinkExplanation: "Diesen Link bitte nicht an Ihre Gruppenteilnehmenden weitergeben. " +
        "Sie benötigen später diesen Link, um die Anmeldungen Ihrer Gruppenteilnehmenden zu überprüfen und zu bestätigen." +
        "Bitte notieren oder speichern Sie deshalb diesen Link, damit Sie später die Gruppenanmeldung abschließen können.",
    groupRegistrarLinkForBuyExplanation: "Diesen Link bitte nicht an Ihre Gruppenmitglieder weitergeben. " +
        "Sie benötigen später diesen Link, um die Bestellungen Ihrer Gruppenmitglieder zu überprüfen und zu bestätigen." +
        "Bitte notieren oder speichern Sie deshalb diesen Link, damit Sie später die Gruppenbestellung abschließen können.",

    copiedLinkToClipboard: "Link wurde kopiert",
    copyLink: "Link kopieren"
}
